import "./Legacy.module.css";
import Header from "@/reusable_sections/Header";
import Milestones from "./sections/Milestones";
import TheFoundationOfErflex from "./sections/TheFoundationOfErflex";
import MastersBehindDecorations from "./sections/MastersBehindDecorations";
import FooterInfo from "@/reusable_sections/Footer";
export default function LegacyPage() {
  return <div>
      <Header />
      <Milestones />
      <TheFoundationOfErflex />
      <MastersBehindDecorations />
      <FooterInfo />
    </div>;
}